import React from 'react';
import { useTranslation } from 'react-i18next';
import { TypeOffre } from '../../../hooks';
import { Typography, Variant } from '../../../styles';

interface TitrePourquoiChoisirProps {
    cssClasse: string;
}

export const TitrePourquoiChoisir: React.FC<TitrePourquoiChoisirProps> = ({
    cssClasse
}) => {
    const [t] = useTranslation(['DetailsOffreModal']);

    return (
        <Typography className={cssClasse} variant={Variant.h3}>
            {t('titreSectionPourquoiChoisir')}
        </Typography>
    );
};

interface TextPourquoiChoisirProps {
    typeOffre: TypeOffre;
    frequence: string;
}

export const TextPourquoiChoisir: React.FC<TextPourquoiChoisirProps> = ({
    typeOffre,
    frequence
}) => {
    const [t] = useTranslation(['DetailsOffreModal']);

    switch (typeOffre) {
        case TypeOffre.SIX_MOIS_FIXE_FERME:
        case TypeOffre.UN_ANS_FIXE_FERME:
        case TypeOffre.DEUX_ANS_FIXE_FERME:
            return (
                <ul>
                    <li>{t('pourquoiEvitezSuprisesBudget')}</li>
                    <li>{t('pourquoiPreferezFlexibiliteCourtTerme')}</li>
                    <li>
                        {t('pourquoiPrevoyezConserverPropriete', {
                            frequence: frequence
                        })}
                    </li>
                </ul>
            );
        case TypeOffre.TRENTE_MOIS_FIXE_FERME:
        case TypeOffre.TROIS_ANS_FIXE_FERME:
        case TypeOffre.TRENTENEUF_MOIS_FIXE_FERME:
        case TypeOffre.QUARANTE_MOIS_FIXE_FERME:
        case TypeOffre.QUARANTE_DEUX_MOIS_FIXE_FERME:
        case TypeOffre.QUATRE_ANS_FIXE_FERME:
            return (
                <ul>
                    <li>{t('pourquoiEvitezSuprisesBudget')}</li>
                    <li>{t('pourquoiPreferezFlexibiliteMoyenTerme')}</li>
                    <li>
                        {t('pourquoiPrevoyezConserverPropriete', {
                            frequence: frequence
                        })}
                    </li>
                </ul>
            );
        case TypeOffre.CINQUANTE_CINQ_MOIS_FIXE_FERME:
        case TypeOffre.CINQ_ANS_FIXE_FERME:
            return (
                <ul>
                    <li>{t('pourquoiEvitezSuprisesBudget')}</li>
                    <li>
                        {t('pourquoiPrevoyezConserverPropriete', {
                            frequence: frequence
                        })}
                    </li>
                </ul>
            );
        case TypeOffre.SIX_ANS_FIXE_FERME:
        case TypeOffre.SEPT_ANS_FIXE_FERME:
        case TypeOffre.DIX_ANS_FIXE_FERME:
            return (
                <ul>
                    <li>{t('pourquoiEvitezSuprisesBudget')}</li>
                    <li>{t('pourquoiPreferezTauxStable')}</li>
                    <li>
                        {t('pourquoiPrevoyezConserverPropriete', {
                            frequence: frequence
                        })}
                    </li>
                    <li>{t('pourquoiEntrainerImportantesConsequences')}</li>
                </ul>
            );
        case TypeOffre.CINQ_ANS_VARIABLE_REDUIT:
            return (
                <ul>
                    <li>{t('pourquoiPayerMoinsInteret')}</li>
                    <li>{t('pourquoiPrevoyezConserver5ans')}</li>
                </ul>
            );
        case TypeOffre.CINQ_ANS_VARIABLE_PROTEGE:
            return (
                <ul>
                    <li>{t('pourquoiAucuneSurprise')}</li>
                    <li>{t('pourquoiRemboursezCapitalPlusVite')}</li>
                    <li>{t('pourquoiProfiterPotentiellesBaissesMaximum')}</li>
                    <li>{t('pourquoiPrevoyezConserver5ans')}</li>
                </ul>
            );
        case TypeOffre.CINQ_ANS_REVISABLE_FERME:
            return (
                <ul>
                    <li>{t('pourquoiToleranceAuRisque')}</li>
                    <li>{t('pourquoiPaiementBaseAnnuelle')}</li>
                    <li>{t('pourquoiProfiterPotentielleBaissesVariable')}</li>
                    <li>{t('pourquoiPrevoyezConserver5ans')}</li>
                </ul>
            );
        default:
            return <></>;
    }
};
